import {getCookie} from '../utils/cookie';
import {randomNumber} from "../utils/number";
import config from '../globalConfig';
import signedToken from "../session/signedToken";

/**
 *
 * Make a request
 * The request might be queued caused by ConnectionsPerHostname of each browser
 * @param {Parcel} parcel
 * @return {Promise}
 */
function add(parcel) {
    // add authorization info
    authentify(parcel);

    if (config.environment === 'DEVELOPMENT') {
        console.log('sending parcel', parcel);
    }

    return new Promise((resolve, reject) => {

        if (parcel.getFakeMode() === 'SUCCESS_IMMEDIATELY') {
            resolve(parcel.parseResponseResult({}).getData());
            return;
        }

        if (parcel.getFakeMode() === 'SUCCESS_DELAY') {
            setTimeout(
                () => resolve(parcel.parseResponseResult({}).getData()),
                randomNumber(500, 3000)
            );
            return;
        }

        if (parcel.getFakeMode() === 'FAIL_IMMEDIATELY') {
            reject(parcel.parseResponseError({}));
            return;
        }

        if (parcel.getFakeMode() === 'FAIL_DELAY') {
            setTimeout(
                () => reject(parcel.parseResponseError({})),
                randomNumber(500, 3000)
            );
            return;
        }

        fetch(
            parcel.getRequestUrl(),
            {
                method: parcel.getRequestMethod(),
                headers: parcel.getRequestHeaders(),
                body: parcel.getRequestBody(),
                mode: 'same-origin',
                credentials: 'same-origin',
            }
        )
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error(`Error ${response.status}: ${response.statusText}.`);
                }

                let contentFormat = parcel.getResponseContentFormat();

                if (!contentFormat) {
                    const contentType = response.headers.get('Content-Type');

                    if (contentType && contentType.includes('application/json')) {
                        contentFormat = 'json';
                    }
                }

                switch (contentFormat) {
                    case 'json': return response.json();
                    case 'formData': return response.formData();
                    case 'arrayBuffer': return response.arrayBuffer();
                    case 'blob': return response.blob();
                    case 'text': return response.text();
                    default: return response.text();
                }
            })
            .then((rawResult) => {
                const responseResult = parcel.parseResponseResult(rawResult);

                if (responseResult.getError() === null) {
                    resolve(responseResult.getData());
                    return;
                }

                reject(responseResult.getError());
            })
            .catch((rawError) => {
                reject(parcel.parseResponseError(rawError));
            });
    });
}

/**
 *
 * Add authentication info to parcel
 * These info can be saved in cookie when an user logged in successfully
 * @param {Parcel} parcel
 */
function authentify(parcel) {
    const token = getAuthToken();

    parcel.setRequestHeader('Authorization', `Bearer ${token}`);
}

/**
 *
 * Get authorization token,
 * that might be saved in browser's cookie when and user logged in successfully
 * @return {string}
 */
function getAuthToken() {
    return signedToken.get() || getCookie('token');
}

export default {
    add
}
